import { render } from "./ActiveInactive.vue?vue&type=template&id=572eecac&scoped=true"
import script from "./ActiveInactive.vue?vue&type=script&lang=js"
export * from "./ActiveInactive.vue?vue&type=script&lang=js"

import "./ActiveInactive.vue?vue&type=style&index=0&id=572eecac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572eecac"]])

export default __exports__